import React, { FunctionComponent } from 'react';
import styles from './Documents.module.scss';
import { DocumentsProps } from './Documents.type';
import Image from 'next/image';

export const Documents: FunctionComponent<DocumentsProps> = ({ documents }) => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Документы</h1>
            <div className={styles.paper}>
                <div>
                    {documents.map((document, i) => (
                        <a
                            key={document.link}
                            href={document.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className={styles.item}
                        >
                            <Image
                                alt=""
                                src={`/assets/dummy-data/documents/${
                                    i + 1
                                }.png`}
                                width={309}
                                height={446}
                            />
                            <p>{document.title}</p>
                        </a>
                    ))}
                </div>
            </div>
            <br />
            <div className={styles.paper}>
                <h3>Заказчикам Пермского края*</h3>
                <div>
                    <a
                        href={
                            '/assets/documents/Регламент работы Call-центра.pdf'
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className={styles.item}
                    >
                        <Image
                            alt=""
                            src={'/assets/dummy-data/documents/call.png'}
                            width={309}
                            height={446}
                        />
                        <p>Регламент работы Call-центра площадки ESTP</p>
                    </a>
                    <a
                        href={
                            '/assets/documents/Регламент_обработки_письменных_обращений.pdf'
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className={styles.item}
                    >
                        <Image
                            alt=""
                            src={'/assets/dummy-data/documents/mail.png'}
                            width={309}
                            height={446}
                        />
                        <p>
                            Регламент обработки письменных обращений площадки
                            ESTP
                        </p>
                    </a>
                </div>
            </div>
        </div>
    );
};
